// Entry point — wired up in 2c.3.
import { boot } from './ui.js';
boot();
